import { gsap } from 'gsap';
import { disableScroll, enableScroll } from '../helpers';

class Search {
    constructor() {
        this.trigger = document.querySelector('.header__topbarSearch');
        this.close = document.querySelector('.search__close');
        this.search = document.querySelector('.search');
        this.popup = document.querySelector('.search__popup');
        this.overlay = document.querySelector('.search__overlay');

        this.results = document.querySelector('.search__results');
        this.resultsInner = document.querySelector('.search__resultsInner');

        this.isOpened = false;
        this.isOpening = false;
        this.tl = gsap.timeline({ paused: true });

        this.setTimeLine();

        this.events();
    }

    setTimeLine() {
        this.tl.to(this.search, {
            duration: 0.4,
            opacity: 1,
            visibility: 'visible',
            ease: 'power1.easeOut',
            onComplete: () => {
                const input = document.querySelector('.search-input__input');
                if (input) input.focus();
            },
        });

        this.tl.to(
            this.popup,
            {
                duration: 0.4,
                opacity: 1,
                y: '-50%',
                ease: 'power1.easeOut',
            },
            '-=0.2'
        );
    }

    events() {
        this.trigger.addEventListener('click', () => this.showSearch());

        this.close.addEventListener('click', () => this.hideSearch());

        this.overlay.addEventListener('click', () => this.hideSearch());

        document.addEventListener('keydown', e =>
            this.keyPressDispatcher.bind(this)(e)
        );

        // Scrolling events
        this.results.addEventListener('wheel', e => {
            e.preventDefault();
            this.results.scrollTop += e.deltaY;
        });

        // Open popup if any ?q param in url is set
        const urlParams = new URLSearchParams(window.location.search);
        const q = urlParams.get('q');
        if (q) {
            this.showSearch();
        }
    }

    showSearch() {
        if (this.isOpened) return;

        this.search.classList.add('active');
        this.tl.timeScale(1);
        this.tl.play();
        this.isOpened = true;

        // Disable global scroll
        disableScroll();
    }

    hideSearch() {
        if (!this.isOpened) return;

        this.search.classList.remove('active');
        this.tl.timeScale(1.5);
        this.tl.reverse();
        this.isOpened = false;

        // Reset global scroll
        enableScroll();
    }

    keyPressDispatcher(e) {
        // Handle ESC key
        if (e.keyCode == 27 && this.search.classList.contains('active')) {
            this.hideSearch();
        }

        // Handle S key
        if (e.keyCode == 83 && !this.search.classList.contains('active')) {
            const inputs = document.querySelectorAll('input, textarea');

            for (let i = 0; i < inputs.length; i++) {
                if (inputs[i] === document.activeElement) return;
            }

            this.showSearch();
        }
    }
}

export default new Search();
